import '@/shared/csrf-token-deprecated';

import $ from '@/bundles/jquery';
import SubmitLoading from "@/shared/submit-loading";
import Toolbox from "@/shared/toolbox";

class HireModal {
    constructor($modal) {
        this.$modal = $modal;
        this.init();
    }

    init() {
        var self = this;

        var $form = this.$modal.find('#form_invite');

        $form.on('submit', function () {
            var designerId = $form.find('input[name="invite"]').val();
            var contestId = $form.find('select[name="contest"]').val();
            var $btn = $form.find('button[type="submit"]');

            SubmitLoading.startLoading($btn);

            $.ajaxCsrf('/invite-designer', {
                method: 'POST',
                dataType: 'json',
                data: {
                    invite: designerId,
                    contest: contestId,
                },
            }).then(function (response) {
                if (response.status === 'error') {
                    Toolbox.error(response.message);
                } else if (response.status === 'ok') {
                    Toolbox.success(response.message);
                    self.$modal.modal('hide');
                }
            }).always(function () {
                SubmitLoading.finishLoading($btn);
            });

            return false;
        });

        this.$modal.modal('show');
    }
}

export default HireModal;
